export default __webpack_public_path__ + "static/media/logo.feba53dc.svg";